import { useCallback, useMemo } from 'react';
import { useTralitSetting } from './useTralitSetting';
import { COMPARE } from '../enum/common.enum';

type LabelInformation = {
  plan: string;
  getCompareLabel: Function;
};

export const useLabel = (): LabelInformation => {
  const { account } = useTralitSetting();

  const ACCOUNT_LABEL_MAP = useMemo(
    () => ({
      sbt: {
        plan: '計画',
      },
      toshiba: {
        plan: '予算',
      },
      toshiba_v2: {
        plan: '予算',
      },
    }),
    []
  );

  const getCompareLabel = useCallback(
    (filter, ratioOrDiff = true) => {
      if (!filter || !account) {
        return '';
      }
      const getSwitchValueText = () => (filter.switchValue ? '比' : '差');
      const getCompareText = () => {
        switch (filter?.compare) {
          case COMPARE.SNAPSHOT_RATIO:
            return '断面';
          case COMPARE.PERIOD_RATIO:
            return '期間';
          case COMPARE.PLANNED_RATIO:
            return ACCOUNT_LABEL_MAP[account].plan;
          case COMPARE.PREVIOUS_YEAR_RATIO:
            return '前年';
          case COMPARE.PREVIOUS_MONTH_RATIO:
            return '前月';
        }
      };
      return `${getCompareText()}${ratioOrDiff ? getSwitchValueText() : ''}`;
    },
    [account]
  );

  return {
    plan: ACCOUNT_LABEL_MAP[account]?.plan,
    getCompareLabel,
  };
};
